import ManagePartners from './partner';
export default ManagePartners;
